(ns com.theplantscape.plant-web.draw.constants
  (:require [clojure.string :as str]))

(defn option-values-fmt [items]
  (reduce (fn [m item] (conj m [item (str/capitalize (name item))])) [["" " - Not set - "]] items))

(def host (.-hostname (.-location js/window)))
(goog-define environment "development")
(goog-define protocol "http")
(goog-define port "3000")
(goog-define do-plant-api-url false)
(goog-define do-plant-image-url "https://img.theplantscape.com/api")
(def do-plant-api (or do-plant-api-url (str protocol "://" host (when port (str ":" port)))))
(def do-plant-img (or do-plant-image-url (str protocol "://" host (when port (str ":" port)))))
;(goog-define do-plant-api "https://plants.digitaloctave.com")
;(def do-plant-api "https://plants.digitaloctave.com")


(defonce point-distance 10)
(defonce display-names {:common "Common" :scientific "Scientific"})
;;https://oreillymedia.github.io/Using_SVG/guide/units.html
(def units {:in 96 :pc 16 :mm 3.7795 :cm 37.795 :m 377.95 :ft 1152 :s 0.001})
(def lifecycles [:annual :perennials :biennials :tender-perenials])
;; should use some other rating
(def hardiness [:hardy :half-hardy])
(def months [:january :feburary :march :april :may :june :july :august :september :october :november :december])
(defonce months-options (option-values-fmt months))
(defonce units-options units #_(option-values-fmt units))
(defonce hardiness-options (option-values-fmt hardiness))
(defonce lifecycle-options (option-values-fmt lifecycles))

;; svg unit equals 1 meter

(defn convert-units [value unit]
  (* value (get units unit 1)))

(defn api-url-build [& rest]
  (str do-plant-api (apply str rest)))

(comment
(convert-units 10 :in)
(convert-units 10 :ft)
(convert-units 10 :s)
         )
